import React, { useState } from 'react'
import { connect } from 'react-redux'
import PowerBIResource from './CatalogContainer.models'

import CatalogItem from '../../../components/resourceCatalog/catalogItem/CatalogItem'

const CatalogItemContainer: React.FC = (props: any) => {
  const [resource, setResource] = useState<PowerBIResource>(props.resource)

  const handleClick = (powerBIResource: PowerBIResource) => {
    const href = `/resource/${powerBIResource.resourceId}`
    setResource(powerBIResource)
    window.open(href, '_blank')
  }

  return (
    <div>
      {resource && (
        <CatalogItem resource={resource} handleClick={handleClick} />
      )}
    </div>
  )
}

function mapStateToProps(state: any, ownProps: any) {
  return {
    resource: ownProps,
  }
}

export default connect(mapStateToProps)(CatalogItemContainer)
